import { styled, Typography } from '@mui/material';
import { COLORS } from '../Constant/COLORS';

import FONTS from '../Constant/FONTS';

export const TypoPoppins = styled(Typography)({
  fontFamily: FONTS.POPP,
});

// Elegant serif display heading (Playfair Display). Pass a variant for size,
// e.g. <TypoSerif variant='h4'>.
export const TypoSerif = styled(Typography)({
  fontFamily: FONTS.SERIF,
});

export const TypoWhite = styled(Typography)({
  color: 'white',
});

export const TypoPoppBlue = styled(TypoPoppins)({
  color: COLORS.blue,
});
